import { useSaveSettings, useSettings } from '../../hooks/queries'
import { useTexte } from '../../texte'
import { fehlertext } from '../../api/client'

/**
 * The installation's default for calculated routes (1.18.0, #84): means of
 * transport and whether tolls are avoided. A trip may override both on its
 * map, in "Punkte verbinden". Saved on change, like the map source -- a
 * switch, not a form.
 */
export function RoutenCard() {
  const t = useTexte()
  const settings = useSettings()
  const save = useSaveSettings()
  const daten = settings.data
  // Without the ceiling this account is no administration -- the server decided.
  if (!daten?.ceiling) return null
  const werte = daten.settings

  return (
    <div className="card card--seite" data-routen-vorgabe="">
      <h2 className="card__titel">{t.routen.titel}</h2>
      <p className="card__lead">{t.routen.lead}</p>
      <label className="field field--luft">
        <span className="field__label">{t.routen.verkehrsmittel}</span>
        <select
          className="field__input"
          name="route_transport"
          value={werte.route_transport}
          disabled={save.isPending}
          onChange={(e) => save.mutate({ route_transport: e.target.value })}
        >
          <option value="Automobile">{t.karte.routen.auto}</option>
          <option value="Cycling">{t.karte.routen.rad}</option>
          <option value="Walking">{t.karte.routen.zuFuss}</option>
        </select>
      </label>
      <label className="routenwahl__maut">
        <input
          type="checkbox"
          name="route_avoid_tolls"
          checked={werte.route_avoid_tolls === '1'}
          disabled={save.isPending}
          onChange={(e) => save.mutate({ route_avoid_tolls: e.target.checked ? '1' : '0' })}
        />
        <span>{t.karte.routen.mautVermeiden}</span>
      </label>
      <p className="leise">{t.karte.routen.nichtAbwaehlbar}</p>
      {save.isError && (
        <p className="notice" role="alert">{fehlertext(save.error)}</p>
      )}
    </div>
  )
}
